import axios from "axios";
import $store from "../store";
import toLogin from "@libs/login";
import { VUE_APP_API_URL } from "@utils/index";

const defaultOpt = { login: true };

function isIpHost(host) {
  if (!host) return false;
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(host.replace(/\/$/, "").split(":")[0]);
}

/** 解析 API 域名：HTTPS 页面禁止走 IP（证书 ERR_CERT_COMMON_NAME_INVALID） */
function resolveApiHost(fwq) {
  let host = (fwq || VUE_APP_API_URL || "").replace(/^https?:\/\//, "").replace(/\/$/, "");
  if (typeof window === "undefined") return host ? host + "/" : VUE_APP_API_URL;

  const pageHost = window.location.hostname;
  const pageIsDomain = pageHost && pageHost !== "localhost" && !isIpHost(pageHost);

  if (pageIsDomain && isIpHost(host)) {
    host = pageHost;
  } else if (
    window.location.protocol === "https:" &&
    isIpHost(host)
  ) {
    host = pageIsDomain ? pageHost : host;
  }

  return host ? host + "/" : VUE_APP_API_URL;
}

function baseRequest(options) {
  let fwqs = $store.state.app.fwq;
  if (fwqs == "null" || fwqs == null || !fwqs) {
    fwqs = VUE_APP_API_URL;
  }
  fwqs = resolveApiHost(fwqs);

  console.log("服务器：" + fwqs);
  
  // 根据当前页面协议自动选择 http 或 https，避免 Mixed Content 错误
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  // 如果域名已经包含协议，则直接使用；否则添加协议
  let baseURL = fwqs;
  if (!fwqs.startsWith('http://') && !fwqs.startsWith('https://')) {
    baseURL = `${protocol}//${fwqs}`;
  }
  
  const instance = axios.create({
    baseURL: baseURL,
    timeout: 30000
  });

  const token = $store.state.app.token;

  console.log("token" + token);
  const headers = options.headers || {};
  headers["token"] = token; //
  headers["Content-Type"] = "application/json ";
  options.headers = headers;
  if (options.login && !token) {
    toLogin();
    return Promise.reject({ msg: "未登录", toLogin: true });
  }
  //   instance.interceptors.reponse.use(res => {
  //    return res
  // }, err => {
  //    console.log(res.reponse)
  //     return Promise.reject(err)
  // })

  // console.log(options);
  return instance(options)
    .then(res => {
      // console.log(res);
      const data = res || {};
      return Promise.resolve(data, res);
    })
    .catch(err => {
      console.log("错误处理");
      if (!err.response) {
        return Promise.reject({ response: { data: { msg: "当前网络异常" } } });
      }
      if (err.response.status == 401) {
        toLogin();
      } else if (err.response.status == 429) {
        return Promise.reject({ response: { data: { msg: "操作频繁" } } });
      } else {
        if (err.response.data.msg) {
          return Promise.reject(err);
        }
        return Promise.reject({ response: { data: { msg: "当前网络异常" } } });
      }
    });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, data, method }, defaultOpt, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, params, method }, defaultOpt, options)
    );
  };
});

export default request;
